@if (ngxMessage) {
  <div class="ngx-editor-message" (dblclick)="clearMessage()">
    {{ ngxMessage }}
  </div>
}
